"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Button = _interopRequireDefault(require("../Buttons/Button"));
var _reactBootstrap = require("react-bootstrap");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const FormUpload = props => {
  const inputRef = _react.default.useRef(null);
  const {
    allowedFileTypes,
    maxFiles,
    disabled
  } = props;
  const [dragOver, setDragOver] = (0, _react.useState)('');
  const [fileList, setFileList] = (0, _react.useState)([]);
  const [errorClass, setErrorClass] = (0, _react.useState)('');
  const [messageClass, setMessageClass] = (0, _react.useState)('form-text');
  const [message, setMessage] = (0, _react.useState)('');
  (0, _react.useEffect)(() => {
    if (allowedFileTypes.length > 1) {
      setMessage(`Acceptable file formats: ${allowedFileTypes.join(', ')}`);
    } else if (allowedFileTypes.length == 0) {
      setErrorClass(' is-invalid');
      setMessageClass('invalid-feedback');
      setMessage(`At least 1 acceptable file format must be set.`);
    } else {
      setMessage(`Acceptable file formats: ${allowedFileTypes}`);
    }
  }, [allowedFileTypes]);
  const handleErrors = (0, _react.useCallback)(files => {
    if (fileList.length > maxFiles - 1 || allowedFileTypes && files.some(file => !allowedFileTypes.some(format => file.name.toLowerCase().endsWith(format.toLowerCase())))) {
      setErrorClass(' is-invalid');
      setMessageClass('invalid-feedback');
      setMessage(`Only following file formats are acceptable: ${allowedFileTypes.join(', ')} `);
    } else {
      setErrorClass('');
      setMessageClass('form-text');
      setMessage(`Acceptable file formats: ${allowedFileTypes.join(', ')}`);
      setFileList(current => [...current, ...files].slice(0, maxFiles));
    }
  }, [allowedFileTypes, fileList, maxFiles]);
  const handleDelete = (0, _react.useCallback)(index => {
    setErrorClass('');
    setMessage(`Acceptable file formats: ${allowedFileTypes.join(', ')}`);
    setFileList(fileList.filter((_, i) => i !== index));
  }, [allowedFileTypes, fileList]);
  const handleDragOff = () => setDragOver('');

  /* istanbul ignore next */
  const handleDragOver = e => {
    e.preventDefault();
    e.stopPropagation();
    setDragOver('drop');
  };

  /* istanbul ignore next */
  const handleDrop = e => {
    e.preventDefault();
    e.stopPropagation();
    setDragOver('');
    const files = [...e.dataTransfer.files];
    handleErrors(files);
  };

  // this covers the mouseclick and keyboard actions to pull up the OS file selector
  const handleSelect = e => {
    e.stopPropagation();
    const files = [...e.target.files];
    handleErrors(files);
  };
  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, null, /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: "file-upload-input"
  }, "Upload", ' ', /*#__PURE__*/_react.default.createElement("span", {
    className: "p"
  }, "(max ", maxFiles, " file", maxFiles == 1 ? '' : 's', ")")), fileList.length < maxFiles && /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, null, /*#__PURE__*/_react.default.createElement("div", {
    id: "file-upload",
    className: 'mm-upload ' + dragOver + errorClass,
    onDragOver: handleDragOver,
    onDragLeave: handleDragOff,
    onDrop: handleDrop
  }, /*#__PURE__*/_react.default.createElement("input", {
    ref: inputRef,
    type: "file",
    id: "file-upload-input",
    multiple: true,
    onChange: handleSelect,
    disabled: disabled
  }), /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: "file-upload-input"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "upload"
  }), /*#__PURE__*/_react.default.createElement("span", null, "Drop file here or click to browse"))), /*#__PURE__*/_react.default.createElement("p", {
    className: messageClass
  }, message)), fileList.map((uploadedFile, index) => {
    return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
      key: index
    }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, {
      htmlFor: 'uploaded-file-' + index,
      className: "sr-only"
    }, "Uploaded File"), /*#__PURE__*/_react.default.createElement(_reactBootstrap.InputGroup, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
      id: 'uploaded-file-' + index,
      value: uploadedFile.name,
      type: "text",
      readOnly: true
    }), /*#__PURE__*/_react.default.createElement(_reactBootstrap.InputGroup.Append, null, /*#__PURE__*/_react.default.createElement(_Button.default, {
      variant: "primary",
      onClick: () => handleDelete(index)
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "sr-only"
    }, "Delete File"), /*#__PURE__*/_react.default.createElement("span", {
      className: "icon-delete",
      "aria-hidden": "true",
      title: "Delete"
    })))));
  }));
};
FormUpload.propTypes = {
  /**
   * The types of files that the upload component can accept
   */
  allowedFileTypes: _propTypes.default.arrayOf(_propTypes.default.string),
  /**
   * The maximum number of files a user is allowed to upload
   */
  maxFiles: _propTypes.default.number,
  /**
   * Disables the Upload Field
   */
  disabled: _propTypes.default.bool
};
FormUpload.defaultProps = {
  allowedFileTypes: ['jpg', 'jpeg', 'png', 'pdf'],
  maxFiles: 4,
  disabled: false
};
var _default = exports.default = FormUpload;